import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {AuthenticationProvider} from '@nh/angular-tses';
import {PermissionsService} from 'app/permissions/permissions.service';
import {Observable} from 'rxjs';
import {filter, mergeMap} from 'rxjs/operators';
import {GlobalAction} from './permissions/types';

@Injectable({
  providedIn: 'root'
})
export class UserLocationsGuard implements CanActivate {
  constructor(private permissionService: PermissionsService, private authenticationProvider: AuthenticationProvider) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.authenticationProvider.isAuthenticated().pipe(
      filter(isAuthenticated => !!isAuthenticated),
      mergeMap(() => {
        return this.permissionService.can(GlobalAction.VIEW_USER_LOCATIONS);
      })
    );
  }
}
